module.exports = "../images/fishing-lodge-3-17.jpg?v=6eeb555";